import { DatePicker } from "../core/components/datePicker.js";
import { FieldInstance } from "../core/components/field.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { Helper } from "../core/util/helper.js";
import React from "react";
export interface DocumentFolderStructureTreeFilterProps {
    onChange: (model, value) => void;
}

export class DocumentFolderStructureTreeFilter extends React.Component<DocumentFolderStructureTreeFilterProps, {
    start?: Date;
    end?: Date;
}>{
    private factory = ComponentHelper.createFactory();

    constructor(props) {
        super(props);
        this.state = {
            start: null,
            end: null
        }
    }

    private getDatePickerStart = () => {
        let props = this.factory.getDefaultDatePickerProps();
        props.field.model = "Start";
        props.value = this.state.start;
        props.onChange = (field, value) => {
            this.setState({ start: value }, () => {
                this.props.onChange(field.model, value);
            })
        }

        return <FieldInstance label={Helper.getTranslation("Auftrag.Start")} >
            <DatePicker {...props} />
        </FieldInstance>
    }

    private getDatePickerEnd = () => {
        let props = this.factory.getDefaultDatePickerProps();
        props.field.model = "End";
        props.value = this.state.end;
        props.onChange = (field, value) => {
            this.setState({ end: value }, () => {
                this.props.onChange(field.model, value);
            })
        }

        return <FieldInstance label={Helper.getTranslation("Auftrag.Ende")}>
            <DatePicker {...props} />
        </FieldInstance>
    }

    render() {
        let startDateTimePicker = this.getDatePickerStart();
        let endDateTimePicker = this.getDatePickerEnd();

        return (<>
                {startDateTimePicker}
                {endDateTimePicker}
        </>);
    }
}